import React, { ReactNode } from 'react';

interface FuturisticBadgeProps {
  variant?: 'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md' | 'lg';
  glow?: boolean;
  pulse?: boolean;
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
}

const FuturisticBadge: React.FC<FuturisticBadgeProps> = ({
  variant = 'primary',
  size = 'md',
  glow = false,
  pulse = false,
  icon,
  className = '',
  children,
}) => {
  const baseClasses =
    'inline-flex items-center justify-center rounded-full font-display font-medium transition-all duration-300 bg-neu-bg';

  const sizeClasses = {
    sm: 'px-3 py-1 text-xs',
    md: 'px-4 py-1.5 text-sm',
    lg: 'px-5 py-2 text-base',
  };

  const getVariantClasses = () => {
    switch (variant) {
      case 'accent':
        return 'text-neu-accent shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
      case 'secondary':
        return 'text-neu-teal shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
      case 'success':
        return 'text-emerald-600 shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
      case 'warning':
        return 'text-amber-600 shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
      case 'error':
        return 'text-red-500 shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
      case 'info':
        return 'text-sky-500 shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
      default: // primary
        return 'text-neu-text shadow-[4px_4px_8px_rgb(163,177,198,0.6),-4px_-4px_8px_rgba(255,255,255,0.5)]';
    }
  };

  return (
    <span
      className={`${baseClasses} ${sizeClasses[size]} ${getVariantClasses()} ${pulse ? 'animate-pulse' : ''} ${className}`}
    >
      {icon && <span className="mr-1.5">{icon}</span>}
      {children}
    </span>
  );
};

export default FuturisticBadge;
